import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { ContactSupportLocations } from "@custom-types/types";
import { Button, MembersDuoIcon } from "@flat-ui";
import { contactSupport } from "@utils/email-utils";
import { isAllMembersTeam } from "@utils/team-utils";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * Whether the teams upgrade offer has to replace the listed teams, which is the case when the
 * workspace subscription does not include teams and none of the teams it created is left.
 *
 * The all-members team does not count: every workspace gets it whatever its subscription is, and
 * it is the one team the listing hides without the feature. Every other team, including the
 * auto-managed email domain ones, stays listed and so rules the offer out.
 *
 * The offer is only made once the teams are known, so that a failed fetch keeps its error page
 * instead of claiming that the workspace has no teams.
 *
 * The teams have to be taken before the page search is applied, otherwise a search without results
 * would offer the upgrade instead of an empty search result.
 */
export function shouldShowTeamsPremiumPage({
  canUseTeams,
  teams,
  status
}) {
  return !canUseTeams && status === "succeeded" && teams.every(isAllMembersTeam);
}

/**
 * Shown on the workspace teams tab when the subscription does not include the
 * teams feature. Mirrors the empty-page style and offers a contact-sales action.
 */
export function TeamsPremiumFeaturePage() {
  const $ = _c(2);
  const {
    trackEvent
  } = useTrackEvent();
  let t0;
  if ($[0] !== trackEvent) {
    t0 = <EmptyPage icon={MembersDuoIcon} title="This is a premium feature" subtitle="Upgrade your subscription to unlock team creation and better organize your users." button={<Button variant="primary" onClick={() => contactSupport({
      location: ContactSupportLocations.teamsPremiumFeature,
      trackEvent
    })}>Contact sales</Button>} />;
    $[0] = trackEvent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}